import { CSSObjectWithLabel, StylesConfig } from 'react-select'

type PositionType = 'absolute' | 'relative' | 'fixed' | 'static' | 'sticky'

export interface CustomStyles {
  control?: CSSObjectWithLabel
  menu?: Partial<CSSObjectWithLabel & { position: PositionType }>
  option?: CSSObjectWithLabel
}

export const inputCustomStyles = (customStyles?: CustomStyles): StylesConfig => ({
  control: () => ({
    backgroundColor: 'white',
    padding: 0,
    display: 'flex',
    position: 'relative',
    cursor: 'pointer',
    ...customStyles?.control,
  }),
  menu: (style) => ({
    ...style,
    position: 'absolute',
    backgroundColor: 'white',
    borderRadius: 16,
    padding: 16,
    overflow: 'hidden',
    /*  RomanTikhonov_1 убрать  important*/
    border: '1px solid black !important',
    zIndex: '1',
    top: 78,
    left: -1,
    width: 'calc(100% + 2px)',
    height: 350,
    overflowY: 'scroll',
    pointerEvents: 'auto',
    '#react-select-2-listbox': {
      overflow: 'visible',
    },
    ...customStyles?.menu,
  }),
  option: (style, { isSelected, isFocused }) => {
    return {
      ...style,
      backgroundColor: isFocused ? '#F0F0F3' : 'white',
      color: '#000',
      borderRadius: 8,
      padding: 16,
      height: '100%',
      zINdex: 11111,
      cursor: 'pointer',
      position: 'relative',
      '&::before': isSelected
        ? {
            content: '""',
            position: 'absolute',
            right: 18,
            top: 16,
            width: 24,
            height: 14,
            border: '3px solid green',
            transform: 'rotate(317deg)',
            borderRight: 'none',
            borderTop: 'none',
          }
        : {},
      '&:active': {
        backgroundColor: '#C0C5CF',
      },
      ...customStyles?.option,
    }
  },
})
